import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { ImageUploader } from "components"
import classes from "./PopdReceipts.module.scss"

const PopdPaymentNote = props => {
  const {
    formErrors,
    paymentDetails,
    setPaymentDetails
  } = props

  const [t] = useTranslation()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const handleAddImage = urls => {
    setPaymentDetails(prev => ({
      ...prev,
      paymentAttachUrls: [...prev.paymentAttachUrls, ...urls]
    }))
  }

  const handleRemoveImage = url => {
    setPaymentDetails(prev => ({
      ...prev,
      paymentAttachUrls:
        prev.paymentAttachUrls.filter(image =>
          image !== url
        )
    }))
  }

  return (
    <div className={classes["container"]}>
      <div className={classes["label"]}>
        {t("پیوست_ها_حداکثر_5_فایل")}
      </div>
      <ImageUploader
        isDeletable
        enableCrop={false}
        maxNumberOfUploads={5}
        accountId={accountId}
        imageCategory="payment"
        onAdded={handleAddImage}
        onRemoved={handleRemoveImage}
        values={paymentDetails.paymentAttachUrls}
      />
      {
        !!formErrors.paymentAttachUrls &&
        <div className={classes["error"]}>
          {formErrors.paymentAttachUrls}
        </div>
      }
    </div>
  )
}

export default PopdPaymentNote